/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pumps_Warning_3Inputs */



/**
* | output |
* | --- |
* | "No feedback from the physical switch" |
*
* @param {Pumps_Warning_3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pumps_warning_3 = /** @type {((inputs?: Pumps_Warning_3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pumps_Warning_3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No feedback from the physical switch")
	return /** @type {LocalizedString} */ ("Absence de retour du commutateur physique")
});